/// <amd-module name="TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Sources/PermissionsSource" />
import { Constants } from "TFS/Views/ProjectOverviewPage/Constants";
import { PermissionsScenarios } from "TFS/Views/ProjectOverviewPage/ProjectOverviewTab/Constants";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssSecurityService } from "VSS/Platform/Security";

export const enum ActivityPaneSecurityConstants {
    NamespaceId = "dc02bf3d-cd48-46c3-8a41-345094ecc94b",
    Token = "/UserIsValid",
    GenericRead = 1
}

export class PermissionsSource {
    constructor(private readonly _pageContext: IVssPageContext) {}

    public getViewActivityPanePermission(): boolean {
        const securityService = this._pageContext.getService<IVssSecurityService>("IVssSecurityService");
        return securityService.hasPermission(
            ActivityPaneSecurityConstants.NamespaceId,
            ActivityPaneSecurityConstants.Token,
            ActivityPaneSecurityConstants.GenericRead
        );
    }
}
